import React, { useContext, useEffect, useState } from 'react';

import { GlobalContext } from '../../../store';

import HandicapIndex from '../../../components/HandicapIndex';
import PlayerSubHeader from '../../../components/PlayerSubHeader';
import { ClubEventToday } from './ClubEventToday/ClubEventToday';
import ClubPicker from './ClubPicker/ClubPicker';
import UpcomingEvents from './Components/UpcomingEvents/UpcomingEvents';
import Invitations from './Components/Invitations/Invitations';
import { CardsContainerStyled, HomeStyled } from './Home.Styles';
import AllClubsEventToday from './Components/AllClubsEventToday';

const Home = () => {
  const {
    actions: {
      clubs: { all: getAllClubs },
      games: { getAllFutureGames },
      events: { getAllFutureEvents }
    }
  } = useContext(GlobalContext);

  const [dataHasBeenRetrieved, setDataHasBeenRetrieved] = useState(false);

  useEffect(() => {
    const retriever = async () => {
      if (!dataHasBeenRetrieved) {
        setDataHasBeenRetrieved(true);

        await getAllClubs();
        await getAllFutureGames();
        await getAllFutureEvents();
      }
    };
    retriever().catch(err => {
      throw new Error(err);
    });
  }, []);

  return (
    <HomeStyled className="home my-clubhouse wrapper">
      <div>
        <PlayerSubHeader title="MY CLUBHOUSE" />

        <CardsContainerStyled>
          <AllClubsEventToday />

          <ClubEventToday />

          <Invitations />

          <ClubPicker />

          <HandicapIndex />

          <UpcomingEvents />
        </CardsContainerStyled>
      </div>
    </HomeStyled>
  );
};

export default Home;
